import { useContext } from 'react';

import { AssetsContext } from '~context/Assets';

export default function useAssets() {
  const context = useContext(AssetsContext);
  if (!context) {
    throw new Error(`useAssets must be used within a AssetsProvider`);
  }
  return context;
}
